import { Controller } from "@hotwired/stimulus";
import { placeRuler } from "../syringe_ruler.js";

const SYRINGE_UNITS = 100;

export default class extends Controller {
  static targets = ["input", "ruler"];

  move() {
    const text = this.inputTarget.value.trim();
    const units = Number(text);
    const shown = text !== "" && Number.isFinite(units) && units > 0 && units <= SYRINGE_UNITS;
    this.rulerTarget.hidden = !shown;
    if (!shown) return;

    const label = `${text} ${units === 1 ? "unit" : "units"} in a ${SYRINGE_UNITS} unit syringe`;
    placeRuler(this.rulerTarget.querySelector("[data-syringe-ruler]"), units, SYRINGE_UNITS, label);
  }
}
